import config from '../../../config'
import store from '../../store'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async get_rutas({}, filtro = {}) {
      return await new Promise(async (resolve, reject) => {
        try {
          const params = new URLSearchParams({
            nombre: filtro.nombre || '',
            path: filtro.path || '',
            menu_id: filtro.menu_id ?? '',
            inhabilitado: filtro.inhabilitado ?? 0
          }).toString()
          const res = await fetch(`${config.API_URL}/rutas-nuevo/search?${params}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          })
          const data = await res.json()
          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async get_ruta_by_id({}, id) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.API_URL}/rutas-nuevo/${id}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          })
          const data = await res.json()
          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async crear_ruta({}, payload) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.API_URL}/rutas-nuevo`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            },
            body: JSON.stringify({
              nombre: payload.nombre,
              path: payload.path,
              menu_id: payload.menu_id || null,
              orden: payload.orden ?? 0
            })
          })
          const data = await res.json()
          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async editar_ruta({}, payload) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.API_URL}/rutas-nuevo/${payload.id}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            },
            body: JSON.stringify({
              nombre: payload.nombre,
              path: payload.path,
              menu_id: payload.menu_id || null,
              orden: payload.orden ?? 0,
              inhabilitado: payload.inhabilitado ?? false
            })
          })
          const data = await res.json()
          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async eliminar_ruta({}, id) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.API_URL}/rutas-nuevo/${id}`, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          })
          const data = await res.json()
          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async get_rutas_activas({}, menuId) {
      return await new Promise(async (resolve, reject) => {
        try {
          const params = menuId ? `?menu_id=${menuId}` : ''
          const res = await fetch(`${config.API_URL}/rutas-nuevo/activos${params}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          })
          const data = await res.json()
          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async get_rutas_por_menu({}, menuId) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.API_URL}/rutas-nuevo/menu/${menuId}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          })
          const data = await res.json()
          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    }
  }
}
